import {Action} from '@ngrx/store';
import {Cultivo} from "../../../../../chacra-core/models/cultivos";

export enum CultivosActionTypes {
  CULTIVOS_LOAD_REQUEST = '[CULTIVOS] Load Request',
  CULTIVOS_LOAD_FAILURE = '[CULTIVOS] Load Failure',
  CULTIVOS_LOAD_SUCCESS = '[CULTIVOS] Load Success'
}

// load
export class CultivosLoadRequestAction implements Action {
  readonly type = CultivosActionTypes.CULTIVOS_LOAD_REQUEST;
}

export class CultivosLoadFailureAction implements Action {
  readonly type = CultivosActionTypes.CULTIVOS_LOAD_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class CultivosLoadSuccessAction implements Action {
  readonly type = CultivosActionTypes.CULTIVOS_LOAD_SUCCESS;

  constructor(public payload: { items: Cultivo[] }) {
  }
}

// actions
export type CultivosActions =
  | CultivosLoadRequestAction
  | CultivosLoadFailureAction
  | CultivosLoadSuccessAction;
